<template>
  <div class="custom-container">
    <div class="wrapper">
      <h1>Cancellation And Refund Conditions</h1>
     <p>Holywoodskyline.com earns income through the way ads are published on the website and the types of advertisements are charged over annual, monthly and weekly periods.</p>
      <p>
        Users who request a movie ad are not charged.</p>
      <p>We offer options for the needs of the user requesting advertising published on Holywoodskyline.com.
        In addition, our company may stop the user's agreement if it sees that the rule (s) specified in any of the articles of Use Agreement have been violated.</p>
      <p>Places that provide advertisement services on Holywoodskyline.com should notify the return of membership fees and cancellation of their membership fees within 3 days after the contract date by e-mail to support@holywoodskyline.com and confirm whether their e-mail has been received by contacting them by phone. will be returned back. No refund will be made for periods outside this period..</p>
      <p>Cancellation and refund of the payment is possible when there are unintentional duplicate payments.</p>
    </div>

  </div>

</template>

<script>
export default {
  name: 'CancelPolicy'
}
</script>

<style lang="scss">
  @import "../assets/scss/components/user-contract";
</style>
